import { DisciplineModel } from '@/src/server/modules/activities/DisciplineModel'
import { escape } from '@/src/server/helpers/leverade-api'

export class DisciplinesService {
  axios

  constructor ({ axios }) {
    this.axios = axios
  }

  async fetchDisciplines (managerId) {
    const { data: { included: disciplines } } = await this.axios('disciplinemanagers', {
      params: {
        'page[size]': 500,
        include: 'discipline',
        query: `manager.id = ${escape(managerId)}`,
      },
    })

    return disciplines.map(this.toDisciplineModel)
  }

  toDisciplineModel (discipline) {
    return new DisciplineModel({
      id: discipline.id,
      name: discipline.attributes.name,
    })
  }
}



// WEBPACK FOOTER //
// ./src/server/modules/activities/DisciplinesService.js